import dynamic from "next/dynamic";

export const BlockQuote = dynamic(() => import("./component"));
